"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var _styleConsts = require("../../utils/styleConsts");

var root = function root(theme, size) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("width:", size, "px;height:", size, "px;font-size:", size, "px;font-weight:", _styleConsts.font.weight.bold, ";cursor:pointer;line-height:1;box-sizing:border-box;user-select:none;display:flex;align-items:center;justify-content:center;")
  );
};

var _default = {
  root: root
};
exports.default = _default;